<template>
  <div class="col-12 col-md-12 col-lg-7 text-center">
    <div class="tit">
      <p>Já possui algum outro emprestimo contratado?</p>
    </div>
    <div class="text-center fixedOptions">
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithCorporateGroup">Sim</button>
      <button type="button" class="btn btn-lg btn-primary" @click="submitWithoutCorporateGroup">Não</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    submitWithCorporateGroup() {

      this.currentUser.Social.OutrosEmprestimos = true  

      this.$emit('on-submit', {Social: this.currentUser.Social})
    },
    submitWithoutCorporateGroup() {

      this.currentUser.Social.OutrosEmprestimos = false    

      this.$emit('on-submit', {Social: this.currentUser.Social})
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/AdditionalInformationSocial/OutrosEmprestimosStep.vue